export default __webpack_public_path__ + "static/media/logo-dark.3ba4db5a.svg";